/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ qty: NonNullable<unknown>, unit: NonNullable<unknown> }} Order_Lot_Trace_Virtual_BodyInputs */

const vi_order_lot_trace_virtual_body = /** @type {(inputs: Order_Lot_Trace_Virtual_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đang chờ nhập bù lô — thiếu ${i?.qty} ${i?.unit}. Khi kho nhập lô mới và bù cho đơn này, phả hệ lô sẽ hiện ở đây.`)
};

/**

* @param {Order_Lot_Trace_Virtual_BodyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_lot_trace_virtual_body = /** @type {((inputs: Order_Lot_Trace_Virtual_BodyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Lot_Trace_Virtual_BodyInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_lot_trace_virtual_body(inputs)
});